<div class="form-group">

  <label [attr.for]="buildChildId()"
         [class.sr-only]="!label"
         [ngClass]="labelStyleModifier">
    {{label}}
  </label>

  <input *ngIf="!isTelephoneField"
    class="form-control {{inputStyleModifier}}"
    [ngClass]="{'page-search': isPageSearch === true, 'error': hasError()}"
    [name]="name || label"
    [type]="isPassword ? 'password' : 'text'"
    [attr.autocomplete]="autocomplete || 'off'"
    [attr.maxlength]="getMaxLength()"
    [attr.disabled]="disabled ? 'disabled' : null"
    [attr.id]="buildChildId()"
    [attr.placeholder]="placeholder || null"
    [attr.aria-required]="required || null"
    [attr.type]="isPasswordField ? 'password' : 'text'"
    [ngModel]="model"
    (ngModelChange)="onModelChange($event)"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event)"
    (focus)="onFocus($event)"
    (focusout)="onFocusOut($event)"
    (keyup.enter)="onEnter($event)"
    #entryComponent
  />

  <input *ngIf="isTelephoneField" telephoneFormatter
         class="form-control {{inputStyleModifier}}"
         [ngClass]="{'page-search': isPageSearch === true}"
         [name]="name || label"
         [attr.autocomplete]="autocomplete || 'off'"
         [attr.maxlength]="getMaxLength()"
         [attr.disabled]="disabled ? 'disabled' : null"
         [attr.id]="buildChildId()"
         [attr.placeholder]="placeholder || null"
         [attr.aria-required]="required || null"
         [ngModel]="model"
         (ngModelChange)="onModelChange($event)"
         (keydown)="onKeyDown($event)"
         (keyup)="onKeyUp($event)"
         (focus)="onFocus($event)"
         (focusout)="onFocusOut($event)"
         (keyup.enter)="onEnter($event)"
         #entryComponent
  />

  <achoo-validation-alerts *ngIf="showError" [component]="this"></achoo-validation-alerts>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-text-field/achoo-text-field.component.html